
import PropTypes from 'prop-types'
import { Input as AntDInput } from 'antd'
import { useField, useFormikContext } from 'formik'
import useClearWhenUnmount from '../../hooks/useClearWhenUnmount'
import Item from './Item'

export default function Input({
  id = undefined,
  label = undefined,
  labelAlign = undefined,
  labelCol = undefined,
  wrapperCol = undefined,
  helperText = '',
  clearWhenUnmount = false,
  layout = undefined,
  ...rest
}) {
  const [fields, { error }, { setValue, setTouched }] = useField(rest)
  const { submitCount } = useFormikContext()
  const InputComp = rest.type === 'password' ? AntDInput.Password : AntDInput
  const hasError = Boolean(submitCount && error)
  const itemProps = {
    hasFeedback: false,
    help: hasError && error,
    htmlFor: id,
    label,
    labelAlign,
    helperText,
    validateStatus: hasError ? 'error' : '',
    layout,
    // This is needed since even sending undefined will override Form's props regarding this
    // so we leave null/false to override, and undefined to keep ignoring (as it should be probably)
    ...(labelCol !== undefined && { labelCol }),
    ...(wrapperCol !== undefined && { wrapperCol }),
  }

  useClearWhenUnmount(clearWhenUnmount, setValue, setTouched)

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Item {...itemProps}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <InputComp id={id} {...fields} {...rest} />
    </Item>
  )
}

Input.propTypes = {
  clearWhenUnmount: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelAlign: PropTypes.string,
  labelCol: PropTypes.shape({}),
  id: PropTypes.string,
  type: PropTypes.string,
  helperText: PropTypes.string,
  wrapperCol: PropTypes.shape({}),
  layout: PropTypes.string,
}
